module.exports = __webpack_public_path__ + "img/LUB00007.8d93dbe2.png";